import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { TweenMax, Quint } from 'gsap';
import { Observable } from 'rxjs/Observable';
import { startWith } from 'rxjs/operators/startWith';
import { map } from 'rxjs/operators/map';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import * as moment from 'moment';

import { AppEventDispatcher } from './../../../utils/AppEventDispatcher';
import { EventTypes } from './../../../shared/EventTypes';

import { ListItem } from '../../../shared/list-confirmation/model/list-item';
import { PaymentFederalTaxes } from './../models/payment-federal-taxes';
import { CodePay } from './../models/code-pay';

import { PaymentFederalTaxesEventType } from './../payment-federal-taxes.event.type';
import { PaymentFederalTaxesService } from './../payment-federal-taxes.service';
import { LimitsService } from '../../limits/limits.service';
import { ModalErrorEventType } from '../../../shared/modal-error/modal-error.event.type';

@Component({
	selector: 'app-payment-darf',
	templateUrl: './payment-darf.component.html',
	styleUrls: ['./payment-darf.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PaymentDarfComponent implements OnInit, OnDestroy {

	@Input() showBalance;
	@Output() showBalanceChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	imagesTax: Array<string> = [
		'assets/imgs/dashboard/ministe-rio-da-fazenda.png',
		'assets/imgs/dashboard/1200-px-logo-receita-federal-do-brasil-svg.png'
	];
	descriptionTax: String = `Ministério da Fazenda - Secretaria da Receita Federal <br>DARF (Documento de Arrecadação de Receitas Federais)`;

	info1: String = `Para o Código da Receita <strong>0089</strong> o Número de Referência é de
	preenchimento obrigatório. <a href="#">Consulte aqui</a> a relação dos códigos
	de Receita que obrigam a digitação do “Número de Referência”.`;

	info2: String = `Encontre mais informações para o cálculo de cotas do IRPF no
	site da Receita Federal através do endereço: <br>
	<a href="http://www.receita.fazenda.gov.br" target="_blank">www.receita.fazenda.gov.br</a>`;

	@Input() paymentData: PaymentFederalTaxes;
	irsCode: Array<CodePay> = [];
	private filteredIrsCode: Observable<CodePay[]>;

	public form: FormGroup;
	private view = '[data-component="payment-darf"]';
	private today: number = Date.now();
	private viewHeight = 0;

	rqdNumRef = false;
	codeSelected = false;
	active = false;
	hasSubimited = false;
	isModal = true;

	cpfcnpj;
	cpfcnpjOld;

	// Calcular o total
	total;
	valueDefault;
	valueTicket;
	valueTax;
	numberMask = createNumberMask({
		prefix: '',
		suffix: '',
		decimalSymbol: ',',
		thousandsSeparatorSymbol: '.',
		allowDecimal: true,
		allowLeadingZeroes: true,
		requireDecimal: 2
	});

	constructor(
		private formBuilder: FormBuilder,
		private paymentService: PaymentFederalTaxesService,
		private limitsService: LimitsService
	) {

		this.form = formBuilder.group({
			name: [null],
			period: [null, Validators.required],
			cpfcnpj: [null, Validators.required],
			recipeCode: [null, Validators.required],
			expDate: [null, Validators.required],
			valueDefault: [null, Validators.required],
			valueTicket: [null],
			valueTax: [null],
			valueTotal: [null, Validators.required],
			refNumber: [null]
		});
	}

	updateTotal() {
		this.valueDefault = this.valueDefault ? this.valueDefault : 0.00;
		this.valueTicket = this.valueTicket ? this.valueTicket : 0.00;
		this.valueTax = this.valueTax ? this.valueTax : 0.00;

		this.total = (this.valueDefault + this.valueTicket + this.valueTax).toFixed(2);
		this.total = this.replaceAt(this.total.toString(), this.total.length - 3, ',');
	}
	replaceAt(element, index, replacement) {
		return element.substr(0, index) + replacement + element.substr(index + replacement.length);
	}

	verifyZeroMain() {
		if ($('.currency-field-main').val() === '0,00') {
			$('.currency-field-main').val('');
		}
	}

	verifyZeroTax() {
		if ($('.currency-field-tax').val() === '0,00') {
			$('.currency-field-tax').val('');
		}
	}

	verifyZeroInt() {
		if ($('.currency-field-int').val() === '0,00') {
			$('.currency-field-int').val('');
		}
	}

	selectCode(e) {
		if (e.source !== undefined) {
			if (e.source.value.idreqRef) {
				this.rqdNumRef = true;
			}
			this.codeSelected = true;
		} else {
			this.codeSelected = false;
		}
	}

	cpfcnpjMask(event) {
		if (event.keyCode === 8) {
		} else if (event.target.value.length <= 19) {
			// remove all mask characters (keep only numeric)
			let newVal = event.target.value.replace(/\D/g, '');

			// don't show braces for empty value
			if (newVal.length === 0) {
				newVal = '';
			} else if (newVal.length <= 3) {
				newVal = newVal.replace(/^(\d{0,3})/, '$1');
			} else if (newVal.length <= 6) {
				newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, '$1.$2');
			} else if (newVal.length <= 9) {
				newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2})/, '$1.$2.$3');
			} else if (newVal.length <= 11) {
				newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2})/, '$1.$2.$3-$4');
			} else if (newVal.length <= 12) {
				newVal = newVal.replace(/^(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,4})/, '$1.$2.$3/$4');
			} else  {
				newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,2})/, '$1.$2.$3/$4-$5');
			}

			// set the new value
			this.cpfcnpjOld = this.cpfcnpj = newVal;
		} else {
			this.cpfcnpj = this.cpfcnpjOld;
		}
	}

	ngOnInit() {
		AppEventDispatcher.listen( PaymentFederalTaxesEventType.STEPS_DARF.PAYMENT_DARF, () => {
			this.active = true;
			this.show();
		});
	}

	setSendListener() {
		AppEventDispatcher.listen( PaymentFederalTaxesEventType.PAYMENT_FEDERAL_TAXES_SEND, () => {
			this.send();
		});
	}

	ngOnDestroy() {
		this.removeListeners();
	}

	removeListeners() {
		AppEventDispatcher.removeListener( PaymentFederalTaxesEventType.PAYMENT_FEDERAL_TAXES_SEND );
		AppEventDispatcher.removeListener( PaymentFederalTaxesEventType.STEPS_DARF.PAYMENT_DARF );
	}

	show() {
		const interval = setInterval(() => {

			if ($(this.view).length > 0) {
				const containerHeight = this.getStepHeight();

				this.viewHeight = containerHeight;

				TweenMax.to('.steps-container', .8, { height: this.viewHeight, ease: Quint.easeOut});
				TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut});
				TweenMax.to('.buttons', .8, {delay: .8, bottom: 0, ease: Quint.easeOut});

				$(this.view).find('input').on('keyup focusout', () => {
					this.updateHeight();
				});

				this.setSendListener();

				this.typePayment();

				clearInterval(interval);
			}

			this.showBalanceChange.emit(true);

		}, 10);
	}

	updateHeight() {
		const interval = setInterval(() => {

			const containerHeight = this.getStepHeight();
			TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut});
			clearInterval(interval);

		}, 10);
	}

	autoCompleteDisplay(codePay: CodePay): any {
		return codePay ? codePay.label : codePay;
	}

	typePayment() {
		this.preload(true);

		let time = 1;
		const timeLoader = setInterval(() => {
			time++;
		}, 1000);

		this.paymentService.getCodePay('DARF').subscribe(data => {

			this.irsCode = data;
			this.filteredIrsCode = this.form.controls.recipeCode.valueChanges.pipe(
				startWith({} as CodePay),
				map(codePay => codePay && typeof codePay === 'object' ? codePay.label : codePay),
				map(label => label ? this.filter(label) : this.irsCode.slice())
			);

			$('.currency-field-main').val('');
			$('.currency-field-tax').val('');
			$('.currency-field-int').val('');
			$('.total-field').val('0,00');

			this.checkAfterSend(timeLoader, time);

		}, error => {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			this.preload(false);
		});
	}

	filter(val): CodePay[] {
		return this.irsCode.filter(irsCode => irsCode.label.includes(val));
	}

	checkAfterSend(timeLoader, time) {

		if (time > 3) {
			this.preload(false);
		}	else {
			TweenMax.delayedCall(3 - time, () => {
				this.preload(false);
			});
		}
		clearInterval(timeLoader);
	}

	hide() {
		this.removeListeners();

		TweenMax.to(this.view, .8, { delay: .4, left: '-100%', ease: Quint.easeOut, onComplete: () => {
			this.active = false;
			AppEventDispatcher.dispatch( PaymentFederalTaxesEventType.STEPS_DARF.CONFIRM_DARF, { show: true });
		}});
	}

	getStepHeight(): number {
		return $(this.view).outerHeight() + $('.buttons').outerHeight() + 60;
	}

	readySend() {
		this.hasSubimited = false;

		this.paymentData.name = this.form.controls.name.value || '';
		this.paymentData.refDate = this.form.controls.period.value;
		this.paymentData.expDate = this.form.controls.expDate.value;
		this.paymentData.cpfcnpj = this.form.controls.cpfcnpj.value.replace(/\D/g, '');
		this.paymentData.recipeCod = this.form.controls.recipeCode.value.code;
		this.paymentData.recipeCodDescription = this.form.controls.recipeCode.value.description;
		this.paymentData.refNumber = this.form.controls.refNumber.value;
		this.paymentData.valueDefault = this.form.controls.valueDefault.value;
		this.paymentData.valueTax = this.form.controls.valueTax.value || 0;
		this.paymentData.valueTicket = this.form.controls.valueTicket.value || 0;
		this.paymentData.valueTotal = this.total;

		this.hide();
	}

	send() {
		this.hasSubimited = true;

		if (this.form.valid && this.codeSelected) {

			this.readySend();

		}

		this.updateHeight();
	}

	minDate() {
		return new Date();
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{element: '[data-component="payment-federal-taxes"] .content', show: active, delay: delay});
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/payment-federal-taxes/payment-darf/payment-darf.component.ts